<template lang="pug">
.control
    .smartcontrolheader(@click="openDocument()")
        font-awesome-icon(:icon="getFileType[0]" :class="getFileType[1]")
        span.title {{ getDocumentName }}

    aiq-tooltip(effect="dark" placement="top" :content="$t(`${baseTranslationPath}.update`)" :show-after="500")
      fa-icon.update-version(:icon="['fas', 'arrow-rotate-left']" class="fa-icon" @click="updateDocs")
    aiq-tooltip(effect="dark" placement="top" :content="$t(`${baseTranslationPath}.version_history`)" :show-after="500")
      fa-icon.update-version(:icon="['fas', 'rectangle-history']" class="fa-icon" @click="showHistory = true")

.updatedocs
    aiq-dialog.modal-editor(:title="$t(`${baseTranslationPath}.update_title`)"
        v-model="showUpdateModal"
        :show-close="true"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        @closed="closeEditor")
        .field-container.full-width.flex-display
            .file-input
                aiq-upload.img-uploader(v-model="imageUrl"
                                :http-request="uploadImage"
                                :action="url"
                                :accept="acceptedFileType"
                                :headers="headers"
                                :show-file-list="false"
                                :multiple="false")
                    .img-uploader-add
            .file-list
                ViewFiles(:record="newFile" :progress="uploadProgress")
        .field-container.full-width.padding-top
            label {{ $t(`${baseTranslationPath}.version`) }}
            aiq-input(v-model="versionUpdate"
                        :disabled="!noFileUploaded"
                        :max-length="250"
                        :placeholder="$t(`${baseTranslationPath}.version`)")
        .field-container.full-width.save-doc-btn
            aiq-button(type="primary" @click="saveDocument") {{ $t('global.save') }}
            aiq-button(class="group-btn" @click="closeEditor") {{ $t('global.cancel') }}


VersionHistory(:smart-control-record="smartControlRecord"
              :showHistory="showHistory"
              @closeHistory="showHistory = false"
              v-if="showHistory")
</template>
<script>
import GetGlobalSource from '@/libs/mixins/GetGlobalSource';
import { iconClasses } from '../../SmartDrive/smartDriveUtil';
import { hosts } from '@/config/api.routes';
import ViewFiles from '../../SmartDrive/ViewFiles.vue';
import VersionHistory from './VersionHistory.vue';
import { IMAGE_ACL_TYPES } from '@/constants';
import get from 'lodash/get';
const COMPLETE_UPLOAD = 100;

export default {
  name: 'ControlListHeader',
  mixins: [GetGlobalSource],
  components: {
    ViewFiles,
    VersionHistory,
  },
  emits: ['update-docs'],
  data() {
    return {
      baseTranslationPath: 'settings_tab.admin_tab.smart_control.control_list_manage',
      showUpdateModal: false,
      imageUrl: '',
      showHistory: false,
      newFile: {
        file: {
          payload: {},
        },
      },
      versionPayload: {},
      url: `${hosts.management}files/upload`,
      uploadProgress: {},
      version: '',
      versionUpdate: '',
      acceptedFileType: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain,text/csv',
      headers: {
        Authorization: this.$store.getters['agent/authToken'],
      },

    };
  },
  props: {
    smartControlRecord: {
      type: Object,
      required: true,
    },
    fileVersion: {
      type: Object,
      required: true,
    },
  },
  watch: {
    versionUpdate(newVal) {
      this.versionPayload = {
        label: newVal,
        file_id: get(this.versionPayload, 'file_id'),
      };
    },
    fileVersion(newVal) {
      this.version = get(newVal, 'label', '');
      this.versionUpdate = this.version;
    },
  },
  mounted() {
    this.version = get(this.fileVersion, 'label', '');
    this.versionUpdate = this.version;
  },
  computed: {
    getDocumentName() {
      return `${get(this.smartControlRecord, 'document.name', '')} (Version ${this.version})`;
    },
    getFileType() {
      const object_type = get(this.fileVersion, 'file.payload.mime', '');
      return iconClasses(object_type);
    },
    getAcl() {
      return get(this.fileVersion, 'file.payload.acl', IMAGE_ACL_TYPES.PRIVATE);
    },
    noFileUploaded() {
      const progress = get(this.uploadProgress, 'uploadPercent', 0);
      return progress === COMPLETE_UPLOAD;
    },
  },
  methods: {
    async openDocument() {
      const url = await this.getFileUrl(get(this.fileVersion, 'file.payload'));
      if (url) {
        window.open(url, '_blank');
      }
    },
    updateDocs() {
      this.showUpdateModal = true;
    },
    saveDocument() {
      this.$emit('update-docs', this.versionPayload);
      this.newFile = {
        file: {
          payload: {},
        },
      };
      this.uploadProgress = {};
      this.closeEditor();
    },
    closeEditor() {
      this.showUpdateModal = false;
    },
    onUploadProgress(progressEvent) {
      const percent = Math.round(
        (progressEvent.loaded * COMPLETE_UPLOAD) / progressEvent.total,
      );
      if (percent !== COMPLETE_UPLOAD) {
        this.uploadProgress = {
          uploadPercent: percent,
          uploadStatus: 'success',
          progressBarStatus: 'in progress',
        };
      } else {
        this.uploadProgress = {
          uploadPercent: percent,
          uploadStatus: 'success',
          progressBarStatus: 'complete',
        };
      }
    },
    async uploadImage(data) {
      const formData = new FormData();
      formData.append('file', data.file);
      formData.append('acl', this.getAcl);

      this.newFile = {
        file: {
          payload: {
            name: data.file.name,
            mime: data.file.type,
            url: '',
          },
        },
      };

      this.uploadProgress = {
        uploadPercent: 0,
        uploadStatus: 'success',
        progressBarStatus: 'in progress',
      };

      try {
        const response = await this.$store.dispatch('files/upload', {
          formData,
          url: this.url,
          onUploadProgress: this.onUploadProgress,
        });

        this.versionPayload = {
          label: this.versionUpdate,
          file_id: response.data.file_id,
        };
      } catch (e) {
        // handle error
        this.uploadProgress = {
          uploadPercent: COMPLETE_UPLOAD,
          uploadStatus: 'exception',
          progressBarStatus: 'failure',
        };
      }
    },
  },

};
</script>
<style lang="scss" scoped>
@import "../../SmartDrive/icon.scss";

.fa-icon:focus,
.fa-icon:active {
  outline: none !important;
  box-shadow: none !important;
}

.modal-editor.el-dialog .img-uploader {
  width: 200px !important;
  height: 200px !important;
}

.update-version {
  cursor: pointer;
  padding-left: 10px;
  padding-top:3px;
}
:deep(.el-dialog.modal-editor) {
  width: 850px !important;
}
.control {
    display: flex;
}

.historybtn {
    margin-left: 10px;
}

.flex-display {
    display: flex;
    gap: 25%;
}
.updatebtn {
    margin-left: 10px;
}

.save-doc-btn {
    margin-bottom: 10px;
    display: flex;
    justify-content: flex-end;
}

.padding-top {
    padding-top: 10px;
}

.file-list {
  margin-bottom: 20px;
}
.smartcontrolheader {
    display: flex;
    align-items: flex-start;
    cursor: pointer;
    margin-left: 10px;
    .title {
        margin-left: 10px;
    }
    &:hover {
      color: #4671B3;
      text-decoration: underline;
      font-weight: bold;
    }
}
</style>